<template>
  <div class="sign-success">
    <div class="submit-success">
      <img src="@static/images/order/refund/submit.png" class="submit-img" />
      <div class="t1">{{ text }}</div>
      <div class="t2">您可以拨打新华保险客服电话<a href="tel:95567">95567</a>查询退保进度</div>
    </div>
  </div>
</template>
<script>
//当前实例组件
export default {
  data() {
    return {
      text: '',
    };
  },
  mounted() {
    if(sessionStorage.refundStaus == 'waitAudit') {
      this.text = '退保提交成功，等待保险公司人工复核';
    } else {
      this.text = '退保成功，等待保险公司退款';
    }
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.submit-success {
  padding-top: 120px;

  .submit-img {
    width: 180px;
    display: block;
    margin: 20px auto 50px;
  }

  .t1 {
    color: #236dff;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
  }
  .t2 {
    color: #888888;
    font-size: 26px;
    text-align: center;
    a {
      color: #236dff;
    }
  }
}
</style>
